var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0085,6.5585c1.035-.011,1.865,.81,1.874,1.853,.009,1.036-.812,1.869-1.852,1.883-1.013,.013-1.879-.842-1.886-1.862-.007-1.031,.821-1.862,1.864-1.874"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.2282,0H9.7719C4.375,0,0,4.375,0,9.7719v15.4562C0,30.625,4.375,35,9.7719,35h15.4563c5.3969,0,9.7719-4.375,9.7719-9.7719V9.7719C35,4.375,30.625,0,25.2282,0Zm8.3546,25.2281c0,4.6067-3.7479,8.3546-8.3546,8.3546H9.7719c-4.6067,0-8.3546-3.7479-8.3546-8.3546V9.7719C1.4173,5.1651,5.1652,1.4173,9.7719,1.4173h15.4563c4.6067,0,8.3546,3.7478,8.3546,8.3546v15.4562Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,10.5617c-3.8262,0-6.9385,3.1123-6.9385,6.9385s3.1123,6.9385,6.9385,6.9385,6.9385-3.1123,6.9385-6.9385-3.1123-6.9385-6.9385-6.9385Zm0,12.46c-3.0444,0-5.5215-2.4771-5.5215-5.5215s2.4771-5.5215,5.5215-5.5215,5.5215,2.4771,5.5215,5.5215-2.4771,5.5215-5.5215,5.5215Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsInsta);
export default __webpack_public_path__ + "static/media/icons_insta.7b6c404b16d8afb7f40883d550888f06.svg";
export { ForwardRef as ReactComponent };